/**
 * Configuração do módulo Mapa: fontes, filtros e métricas.
 *
 * Os filtros são dimensões da tabela de acessos (user_data); as chaves batem com
 * os parâmetros de /api/mapa/geo e /api/mapa/options.
 */

import { METRIC_FILTERS } from './metricFilters.js'

// `logo` = imagem em public/logos/integracao; sem logo, usa o ícone `icon`.
export const MAPA_SOURCES = [
  { key: 'google_ads', label: 'Google Ads', logo: '/logos/integracao/google_ads.webp', hint: 'Acessos de tráfego pago (gclid ou origem google_ads).' },
  { key: 'seo', label: 'SEO', icon: 'search', hint: 'Acessos sem gclid (orgânico, mesma regra do módulo SEO).' },
  { key: 'meta', label: 'Meta Ads', logo: '/logos/integracao/meta-ads.png', hint: 'Acessos com origem Meta (Facebook/Instagram ou clique com fbc).' },
  { key: 'all', label: 'Todas', icon: 'grid', hint: 'Todos os acessos, pagos e orgânicos.' },
]

export const MAPA_DEFAULT_SOURCE = 'google_ads'

// Filtros em lista (acordeão). A origem (utm_source) é escolhida no dropdown de
// Fonte, que lista as origens reais dos dados.
export const MAPA_FILTERS = [
  { key: 'midia', label: 'Mídia', placeholder: 'Buscar mídia...' },
  { key: 'campanha', label: 'Campanha', placeholder: 'Buscar campanha...' },
  { key: 'pagina', label: 'Página', placeholder: 'Buscar página...' },
  { key: 'referer', label: 'Referer', placeholder: 'Buscar referer...' },
  { key: 'dispositivo', label: 'Dispositivo', placeholder: 'Buscar dispositivo...' },
  { key: 'palavra', label: 'Palavra-chave', placeholder: 'Buscar palavra-chave...' },
]

// Nomes amigáveis e logos das origens mais comuns; qualquer origem nova aparece
// no dropdown com o valor gravado e um ícone genérico.
export const ORIGIN_LABELS = {
  ig: 'Instagram',
  instagram: 'Instagram',
  fb: 'Facebook',
  facebook: 'Facebook',
  meta: 'Meta',
  direto: 'Direto',
  '(sem origem)': 'Sem origem',
  'chatgpt.com': 'ChatGPT',
  'www.google.com': 'Google (orgânico)',
  'www.bing.com': 'Bing',
  linkedin: 'LinkedIn',
  whatsapp: 'WhatsApp',
  gemini: 'Gemini',
  'gemini.google.com': 'Gemini',
  'copilot.com': 'Copilot',
  'www.youtube.com': 'YouTube',
}
export const ORIGIN_LOGOS = {
  ig: '/logos/integracao/instagram.svg',
  instagram: '/logos/integracao/instagram.svg',
  fb: '/logos/integracao/facebook.svg',
  facebook: '/logos/integracao/facebook.svg',
  meta: '/logos/integracao/meta-ads.png',
  whatsapp: '/logos/integracao/whatsapp.webp',
}
export const originLabel = (value) => ORIGIN_LABELS[value] || value

// Origens que já são cobertas por um grupo do topo do dropdown (Google Ads pago).
export const ORIGINS_HIDDEN_IN_LIST = ['google_ads']

// Métricas derivadas dos acessos (investimento, impressões e cliques vêm das
// tabelas de anúncios e não são filtráveis por página, referer etc.).
const MAPA_METRIC_KEYS = ['visits', 'whats', 'forms', 'contacts', 'leads', 'qualified', 'sales']
export const MAPA_METRICS = METRIC_FILTERS.filter((m) => MAPA_METRIC_KEYS.includes(m.key))
export const MAPA_DEFAULT_METRIC = 'leads'

// `origem` vem do dropdown de Fonte e também faz parte do estado dos filtros.
export const MAPA_EMPTY_FILTERS = Object.fromEntries(
  [{ key: 'origem' }, ...MAPA_FILTERS].map((f) => [f.key, []]),
)

// Conta só os filtros da lista (a origem escolhida na Fonte não entra).
export const countActiveFilters = (filters) =>
  MAPA_FILTERS.reduce((n, f) => n + (filters?.[f.key]?.length || 0), 0)

// Comparação de cidades: até 4, cada uma com a sua cor (borda no mapa e no painel).
export const MAX_COMPARE_CITIES = 4
export const COMPARE_COLORS = ['#1D4ED8', '#EA580C', '#059669', '#9333EA']
